import { isDev } from '../util';

export const getDevLang = () => (isDev() ? 'zh' : import.meta.env.VITE_APP_LANG);

// bycursor-start
/**
 * 获取开发环境Token
 * @author bycursor
 * @returns {string} Bearer token
 */
export const getDevToken = () => {
  const customToken = sessionStorage.getItem('devToken');
  return customToken
    ? `Bearer ${customToken}`
    : `Bearer eyJhbGciOiJIUzUxMiJ9.eyJjcmVhdGVkVGltZSI6MTc3NjQxNTMxMjY3NiwiY2xpZW50IjoiQ3JlZml0IiwibGlua1R5cGUiOiIiLCJ1c2VySWQiOiIxNTA4Nzc1In0.J40Bqo3vTdRh-hKwjeirW0fF3CxjhPhxhXWF357T6YBej9InAXESn7IK34qNCLtFr4MyMjRPX1Iut0eKudI_Cw`;
};
// bycursor-end

export const getDevIsUIv2 = () =>
  isDev() ? true : import.meta.env.VITE_APP_NEW_VERSION === 'true';

// Contains cursor-generated edits.
